import { suppressKeyboardEvent } from './KeyboardNavigation';
import { CONSTANTS } from './GridHelpers';

const {
  FOCUSABLE_CELL_CLASS,
  EDITABLE_CELL_CLASS,
  ROW_ACTION_COLID,
  SELECTION_COLID,
  ROW_ACTION_BUTTON_CLASS,
  ACTION_COLUMN_WIDTH,
  COMPACT_ACTION_COLUMN_WIDTH,
  TOGGLE_COLUMN_WIDTH,
  COLORBAR_COLUMN_WIDTH,
  CHECKBOX_COLUMN_WIDTH,
  SELECTION_COLUMN_WIDTH,
  CELL_NO_PADDING
} = CONSTANTS;

export const numericCell = {
  type: 'numericColumn',
  // Need to add 'ag-right-aligned-cell' to cell class explicitly when use cellClass in numericColumn
  cellClass: 'ag-right-aligned-cell ccfk-DataGrid-tabular-number-column',
  headerClass: 'ag-right-aligned-header ccfk-DataGrid-tabular-number-column',
};

export const editableCell = {
  editable: true,
  cellClass: (params) => {
    let classNames = EDITABLE_CELL_CLASS;
    if (params.colDef.type && params.colDef.type.indexOf('numericColumn') !== -1) {
      classNames = `${classNames} ag-right-aligned-cell`;
    }
    return classNames;
  },
  cellRenderer: 'CellEditorRenderer',
  cellEditor: 'CellEditor',
};

export const defaultColDef = {
  suppressMenu: false,
  sortable: true,
  resizable: true,
  menuTabs: ['filterMenuTab', 'generalMenuTab'],
  floatingFilterComponent: 'FloatingFilter',
  suppressKeyboardEvent
};

export const actionColumn = {
  colId: ROW_ACTION_COLID,
  editable: false,
  sortable: false,
  resizable: false,
  suppressMenu: true,
  suppressSizeToFit: true,
  suppressMovable: true,
  suppressColumnsToolPanel: true,
  suppressFiltersToolPanel: true,
  minWidth: COMPACT_ACTION_COLUMN_WIDTH,
  maxWidth: ACTION_COLUMN_WIDTH,
  width: ACTION_COLUMN_WIDTH,
  cellRenderer: 'RowActions',
  cellClass: `${FOCUSABLE_CELL_CLASS} ${ROW_ACTION_BUTTON_CLASS} ${CELL_NO_PADDING}`,
  headerClass: ROW_ACTION_BUTTON_CLASS
};

export const colorBarColumn = {
  resizable: false,
  suppressSizeToFit: true,
  suppressMovable: true,
  suppressColumnsToolPanel: true,
  suppressFiltersToolPanel: true,
  width: COLORBAR_COLUMN_WIDTH,
  cellClass: CELL_NO_PADDING,
  cellRenderer: 'ColorBar'
};

export const toggleButtonColumn = {
  width: TOGGLE_COLUMN_WIDTH,
  editable: false,
  cellClass: FOCUSABLE_CELL_CLASS,
  cellRenderer: 'ToggleButtonCell'
};

export const checkboxColumn = {
  width: CHECKBOX_COLUMN_WIDTH,
  editable: false,
  cellClass: FOCUSABLE_CELL_CLASS,
  cellRenderer: 'CheckboxCell'
};

export const selectionColumn = {
  colId: SELECTION_COLID,
  headerCheckboxSelection: true,
  headerCheckboxSelectionFilteredOnly: true,
  checkboxSelection: true,
  editable: false,
  width: SELECTION_COLUMN_WIDTH,
};
